import { CACHE_KEYS } from '@/common/constants'
import axios from 'axios'

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL
})


api.interceptors.request.use(config => {
  const token = localStorage.getItem(CACHE_KEYS.TOKEN)
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }

  return config
})

export { api }